import _asyncToGenerator from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2019-2022 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert } from '@polkadot/util';
import { bridge, initBridge } from "./init.js";
export { packageInfo } from "./packageInfo.js";
export { bridge };

function withWasm(fn) {
  return function () {
    assert(bridge.wasm, 'The WASM interface has not been initialized. Ensure that you wait for the initialization Promise with waitReady() from @polkadot/wasm-crypto (or cryptoWaitReady() from @polkadot/util-crypto) before attempting to use WASM-only interfaces.');

    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    return fn.apply(void 0, [bridge.wasm].concat(params));
  };
}

export var bip39Generate = withWasm(function (wasm, words) {
  wasm.ext_bip39_generate(8, words);
  return bridge.resultString();
});
export var bip39ToEntropy = withWasm(function (wasm, phrase) {
  wasm.ext_bip39_to_entropy.apply(wasm, [8].concat(_toConsumableArray(bridge.allocString(phrase))));
  return bridge.resultU8a();
});
export var bip39ToMiniSecret = withWasm(function (wasm, phrase, password) {
  wasm.ext_bip39_to_mini_secret.apply(wasm, [8].concat(_toConsumableArray(bridge.allocString(phrase)), _toConsumableArray(bridge.allocString(password))));
  return bridge.resultU8a();
});
export var bip39ToSeed = withWasm(function (wasm, phrase, password) {
  wasm.ext_bip39_to_seed.apply(wasm, [8].concat(_toConsumableArray(bridge.allocString(phrase)), _toConsumableArray(bridge.allocString(password))));
  return bridge.resultU8a();
});
export var bip39Validate = withWasm(function (wasm, phrase) {
  var ret = wasm.ext_bip39_validate.apply(wasm, _toConsumableArray(bridge.allocString(phrase)));
  return ret !== 0;
});
export var ed25519KeypairFromSeed = withWasm(function (wasm, seed) {
  wasm.ext_ed_from_seed.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(seed))));
  return bridge.resultU8a();
});
export var ed25519Sign = withWasm(function (wasm, pubkey, seckey, message) {
  wasm.ext_ed_sign.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(pubkey)), _toConsumableArray(bridge.allocU8a(seckey)), _toConsumableArray(bridge.allocU8a(message))));
  return bridge.resultU8a();
});
export var ed25519Verify = withWasm(function (wasm, signature, message, pubkey) {
  var ret = wasm.ext_ed_verify.apply(wasm, _toConsumableArray(bridge.allocU8a(signature)).concat(_toConsumableArray(bridge.allocU8a(message)), _toConsumableArray(bridge.allocU8a(pubkey))));
  return ret !== 0;
});
export var secp256k1FromSeed = withWasm(function (wasm, seckey) {
  wasm.ext_secp_from_seed.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(seckey))));
  return bridge.resultU8a();
});
export var secp256k1Compress = withWasm(function (wasm, pubkey) {
  wasm.ext_secp_pub_compress.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(pubkey))));
  return bridge.resultU8a();
});
export var secp256k1Expand = withWasm(function (wasm, pubkey) {
  wasm.ext_secp_pub_expand.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(pubkey))));
  return bridge.resultU8a();
});
export var secp256k1Recover = withWasm(function (wasm, msgHash, sig, recovery) {
  wasm.ext_secp_recover.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(msgHash)), _toConsumableArray(bridge.allocU8a(sig)), [recovery]));
  return bridge.resultU8a();
});
export var secp256k1Sign = withWasm(function (wasm, msgHash, seckey) {
  wasm.ext_secp_sign.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(msgHash)), _toConsumableArray(bridge.allocU8a(seckey))));
  return bridge.resultU8a();
});
export var sr25519DeriveKeypairHard = withWasm(function (wasm, pair, cc) {
  wasm.ext_sr_derive_keypair_hard.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(pair)), _toConsumableArray(bridge.allocU8a(cc))));
  return bridge.resultU8a();
});
export var sr25519DeriveKeypairSoft = withWasm(function (wasm, pair, cc) {
  wasm.ext_sr_derive_keypair_soft.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(pair)), _toConsumableArray(bridge.allocU8a(cc))));
  return bridge.resultU8a();
});
export var sr25519DerivePublicSoft = withWasm(function (wasm, pubkey, cc) {
  wasm.ext_sr_derive_public_soft.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(pubkey)), _toConsumableArray(bridge.allocU8a(cc))));
  return bridge.resultU8a();
});
export var sr25519KeypairFromSeed = withWasm(function (wasm, seed) {
  wasm.ext_sr_from_seed.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(seed))));
  return bridge.resultU8a();
});
export var sr25519Sign = withWasm(function (wasm, pubkey, secret, message) {
  wasm.ext_sr_sign.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(pubkey)), _toConsumableArray(bridge.allocU8a(secret)), _toConsumableArray(bridge.allocU8a(message))));
  return bridge.resultU8a();
});
export var sr25519Verify = withWasm(function (wasm, signature, message, pubkey) {
  var ret = wasm.ext_sr_verify.apply(wasm, _toConsumableArray(bridge.allocU8a(signature)).concat(_toConsumableArray(bridge.allocU8a(message)), _toConsumableArray(bridge.allocU8a(pubkey))));
  return ret !== 0;
});
export var sr25519Agree = withWasm(function (wasm, pubkey, secret) {
  wasm.ext_sr_agree.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(pubkey)), _toConsumableArray(bridge.allocU8a(secret))));
  return bridge.resultU8a();
});
export var vrfSign = withWasm(function (wasm, secret, context, message, extra) {
  wasm.ext_vrf_sign.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(secret)), _toConsumableArray(bridge.allocU8a(context)), _toConsumableArray(bridge.allocU8a(message)), _toConsumableArray(bridge.allocU8a(extra))));
  return bridge.resultU8a();
});
export var vrfVerify = withWasm(function (wasm, pubkey, context, message, extra, outAndProof) {
  var ret = wasm.ext_vrf_verify.apply(wasm, _toConsumableArray(bridge.allocU8a(pubkey)).concat(_toConsumableArray(bridge.allocU8a(context)), _toConsumableArray(bridge.allocU8a(message)), _toConsumableArray(bridge.allocU8a(extra)), _toConsumableArray(bridge.allocU8a(outAndProof))));
  return ret !== 0;
});
export var blake2b = withWasm(function (wasm, data, key, size) {
  wasm.ext_blake2b.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(data)), _toConsumableArray(bridge.allocU8a(key)), [size]));
  return bridge.resultU8a();
});
export var hmacSha256 = withWasm(function (wasm, key, data) {
  wasm.ext_hmac_sha256.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(key)), _toConsumableArray(bridge.allocU8a(data))));
  return bridge.resultU8a();
});
export var hmacSha512 = withWasm(function (wasm, key, data) {
  wasm.ext_hmac_sha512.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(key)), _toConsumableArray(bridge.allocU8a(data))));
  return bridge.resultU8a();
});
export var keccak256 = withWasm(function (wasm, data) {
  wasm.ext_keccak256.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(data))));
  return bridge.resultU8a();
});
export var keccak512 = withWasm(function (wasm, data) {
  wasm.ext_keccak512.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(data))));
  return bridge.resultU8a();
});
export var pbkdf2 = withWasm(function (wasm, data, salt, rounds) {
  wasm.ext_pbkdf2.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(data)), _toConsumableArray(bridge.allocU8a(salt)), [rounds]));
  return bridge.resultU8a();
});
export var scrypt = withWasm(function (wasm, password, salt, log2n, r, p) {
  wasm.ext_scrypt.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(password)), _toConsumableArray(bridge.allocU8a(salt)), [log2n, r, p]));
  return bridge.resultU8a();
});
export var sha256 = withWasm(function (wasm, data) {
  wasm.ext_sha256.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(data))));
  return bridge.resultU8a();
});
export var sha512 = withWasm(function (wasm, data) {
  wasm.ext_sha512.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(data))));
  return bridge.resultU8a();
});
export var twox = withWasm(function (wasm, data, rounds) {
  wasm.ext_twox.apply(wasm, [8].concat(_toConsumableArray(bridge.allocU8a(data)), [rounds]));
  return bridge.resultU8a();
});
export function isReady() {
  return !!bridge.wasm;
}
export function waitReady() {
  return _waitReady.apply(this, arguments);
}

function _waitReady() {
  _waitReady = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var wasm;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return initBridge();

          case 3:
            wasm = _context.sent;
            return _context.abrupt("return", !!wasm);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _waitReady.apply(this, arguments);
}